export class AnnouncementModel {
dtFromDate: string;
dtTodate: string;
cstmType: string;
setValue(res){
if(res){
if(res['dtFromDate']){this.dtFromDate = res['dtFromDate'];}
if(res['dtTodate']){this.dtTodate = res['dtTodate'];}
if(res['cstmType']){this.cstmType = res['cstmType'];}
}
}
}